import React from "react";
import { useTranslation } from "react-i18next";

export default function Mul(): JSX.Element {
    const { t } = useTranslation("assessment");
    return (
        <>
            <h3>{t("mul.title") as string}</h3>
            <p>{t("mul.list-title-1") as string}</p>
            <ul>
                <li>{t("mul.list-1.point-1") as string}</li>
                <li>{t("mul.list-1.point-2") as string}</li>
                <li>{t("mul.list-1.point-3") as string}</li>
            </ul>
            <p>{t("mul.paragraph-1") as string}</p>
            <p>{t("mul.paragraph-2") as string}</p>
            <p>{t("mul.list-title-2") as string}</p>
            <ul>
                <li>{t("mul.list-2.point-1") as string}</li>
                <li>{t("mul.list-2.point-2") as string}</li>
                <li>{t("mul.list-2.point-3") as string}</li>
                <li>{t("mul.list-2.point-4") as string}</li>
            </ul>
            <p>{t("mul.paragraph-3") as string}</p>
            <p>{t("mul.paragraph-4") as string}<a className="bolder-text" href={t("mul.hyperlink") as string} target='_blank' rel="noopener noreferrer">{t("mul.hyperlink-text") as string}</a>.</p>
        </>
    );
}